module.exports = "<vb-generic-selection-input\r\n  inputId=\"accountingUnit-input\"\r\n  label=\"Kostenstelle\"\r\n  [control]=\"control\"\r\n  [optional]=\"false\"\r\n  [items]=\"accountingUnits$ | async\"\r\n  [itemLabel]=\"accountingUnitLabel\"\r\n  [selectedItem]=\"item\"\r\n  (itemChanged)=\"onItemChangedEvent($event)\">\r\n</vb-generic-selection-input>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/crm/accounting-units/accounting-unit-selection/accounting-unit-selection.component.html
// module id = ./src/app/crm/accounting-units/accounting-unit-selection/accounting-unit-selection.component.html
// module chunks = main